// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2qGCJ","loaderOuter":"PageOverlayLoader_loaderOuter__BMBi9"};